const STORAGE_KEY = 'auth';

export function getAuthToken() {
  return localStorage.getItem(STORAGE_KEY);
}

export function setAuthToken(token?: string) {
  if (token) localStorage.setItem(STORAGE_KEY, token);
  else localStorage.removeItem(STORAGE_KEY);
}
